import React from "react";

export default function DetailWelcome() {
	return null;
}